// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ad-trigger":"_3xdSVy","active":"_1o3mx2","on-background":"_1Mv8Zn"};